import { render, staticRenderFns } from "./downloadTheFileAdjustmentLetter.vue?vue&type=template&id=47a0cf3c&scoped=true&"
import script from "./downloadTheFileAdjustmentLetter.vue?vue&type=script&lang=js&"
export * from "./downloadTheFileAdjustmentLetter.vue?vue&type=script&lang=js&"
import style0 from "./downloadTheFileAdjustmentLetter.vue?vue&type=style&index=0&id=47a0cf3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a0cf3c",
  null
  
)

export default component.exports